import { Box } from "@mui/material";
import { PrimaryFormLoadingActionButton } from "../../../Features/Table/GenericDraggableTable/TableStyles";

const AddChartButton = ({ onClick }) => {
    return (
        <Box>
            <PrimaryFormLoadingActionButton
                onClick={onClick}
                sx={{
                    backgroundColor: 'transparent',
                    color: '#6D72F6',
                    '&:hover': {
                        backgroundColor: '#6D72F6',
                        color: '#FFFFFF !important',
                    }
                }}
            >
                Add Chart
            </PrimaryFormLoadingActionButton>
        </Box>
    )
}

export default AddChartButton;
